export const ProvinceTax = [
    {
        provinceName: 'Alberta',
        gst: '5'
    },
    {
        provinceName: 'British Columbia',
        gst: '5',
        pst: '7'
    },
    {
        provinceName: 'Manitoba',
        gst: '5',
        pst: '7'
    },
    {
        provinceName: 'New Brunswick',
        hst: '15',
    },
    {
        provinceName: 'Newfoundland and Labrador',
        hst: '15',
    },
    {
        provinceName: 'Northwest Territories',
        gst: '5'
    },
    {
        provinceName: 'Nova Scotia',
        hst: '15',
    },
    {
        provinceName: 'Nunavut',
        gst: '5'
    },
    {
        provinceName: 'Ontario',
        hst: '13',
    },
    {
        provinceName: 'Prince Edward Island',
        hst: '15',
    },
    {
        provinceName: 'Quebec',
        gst: '5',
        pst: '9.975'
    },
    {
        provinceName: 'Saskatchewan',
        gst: '5',
        pst: '6'
    },
    {
        provinceName: 'Yukon',
        gst: '5'
    },
]